__turbopack_context__.v({
  "button": "modal-module-scss-module__zxRfSG__button",
  "close": "modal-module-scss-module__zxRfSG__close",
  "modal": "modal-module-scss-module__zxRfSG__modal",
  "wrapper": "modal-module-scss-module__zxRfSG__wrapper",
});
